module.exports = __webpack_public_path__ + "static/media/nov2024-5.da8f6dab.webp";